<template>
	<v-main>
		<v-card tile>
			<v-row class="d-flex justify-center" style="max-height: 48px;" :style="{backgroundColor: auditoriumColor.highlightBackgroundColor}">
				<v-col cols="8" sm="6" class="py-0" :style="styleObject1">
					<v-text-field
						height="100%"
						class="auditorium_search_bar"
						:background-color="auditoriumColor.searchBarColor"
						:color="auditoriumColor.searchBarFontColor"
						solo
						flat
						placeholder="Search within current track"
						prepend-inner-icon="mdi-magnify"
						single-line
						hide-details
						v-model="searchTitle"
						v-on:keyup.enter=" listPresentationByTrackIdTitle2(searchTitle) "
					></v-text-field>
				</v-col>
			</v-row>
			<v-tabs v-model="tab" icons-and-text :background-color="auditoriumColor.backgroundColor" show-arrows dark>
				<span v-for="(item, index) in trackList" :key="index">
					<v-tab @click="selectTrack(item.id)">
						<v-col class="text-left" :style="{color: auditoriumColor.fontColor}">
							<h5 style="font-size: 8px;">Track {{index+1}}:</h5>
							{{ item.name }}
						</v-col>
					</v-tab>
				</span>
			</v-tabs>

			<v-tabs-items v-model="tab">
				<!-- Choose Track to List Presentation -->
				<v-tab-item v-for="(itemTrack, indexTrack) in trackList" :key="indexTrack">
					<v-expansion-panels v-model="panel" accordion tile dark>
						<v-expansion-panel v-for="(itemDate, index) in dateList" :key="index" @click="scrollToTop(index)" style="background-color: #FFFFFF00;">
							<v-expansion-panel-header expand-icon v-if="!itemTrack.dataMap.expand" :style="{backgroundColor: auditoriumColor.dateBackgroundColor}">
								<v-row class="d-flex align-center mx-4">
									<v-container style="padding: 0;" class="text-center">
										<span style="font-weight: bold;" :style="{color: auditoriumColor.fontColor}">{{ itemDate.value }}</span>
									</v-container>
								</v-row>
							</v-expansion-panel-header>
							<v-expansion-panel-content class="presentation">
								<div v-for="(sessionItem, sessionIndex) in itemDate.sessionList" :key="sessionIndex">
									<v-row
										v-for="(item,index) in sessionItem.presentationList"
										:key="index"
										:style="{
											backgroundColor: sessionIndex%2 == 1 ? auditoriumColor.additionalBackgroundColor : auditoriumColor.backgroundColor,
											color: auditoriumColor.fontColor
										}"
										style="margin-left: 0; margin-right: 0;"
									>
										<v-container style="padding: 0;">
											<v-row class="mx-4" v-if="index == 0">
												<v-col cols="12" sm="2"></v-col>
												<v-col cols="12" sm="10">
													<h2>{{ sessionItem.value != 'null' ? sessionItem.value : "" }}</h2>
												</v-col>
											</v-row>
											<v-row class="d-flex mx-4">
												<v-col cols="12" sm="2" class="pt-6">
													<span
														style="font-weight: bold;"
														v-if="item.type != typeOnDemandVideo"
													>{{ formatTime12Hours(item.dataMap.startTime) }} - {{ formatTime12Hours(item.dataMap.endTime) }} {{timeZoneText}}</span>
												</v-col>
												<v-col cols="12" sm="10">
													<h3 style="margin-bottom:10px;">{{ item.title }}</h3>
													<div v-for="(topic, indexTopic) in item.topicList" :key="indexTopic">
														<div class="d-flex flex-row mb-2" v-for="(presenter, indexPresenter) in topic.presenterList" :key="indexPresenter">
															<v-avatar
																size="80"
																color="teal"
																style="margin-left: 0px; margin-right: 10px;cursor: pointer;"
																@click="selectedPresenterName = presenterName(presenter); selectedPresenterBio = presenter.bio; dialogBio = true; "
															>
																<v-img v-if="presenter.image != null && !imgError[presenter.id]" :src="baseLocation + '/asset/file/user/' + presenter.image + '?c=' + imgCaching" @error="imgError[presenter.id] = !imgError[presenter.id]" />
																<v-img v-else :src="baseLocation + '/resource/image/default-avatar.png'" />
															</v-avatar>
															<div class="mt-3">
																<a
																	style="color: white; text-decoration: none;"
																	@click="selectedPresenterName = presenterName(presenter); selectedPresenterBio = presenter.bio; dialogBio = true; "
																>{{ presenterName(presenter) }}</a>
																<div class="mt-2 body-2" v-if="topic.value != null">{{ topic.value }}</div>
															</div>
															<br />
														</div>
													</div>
													<p class="mt-4 body-2" v-html="item.description"></p>

													<section class="accordion">
														<input type="checkbox" name="collapse" :id="indexTrack + '-' + item.id" />
														<div class="handle d-flex flex-row align-center">
															<label :for="indexTrack + '-' + item.id" v-show="item.handoutList && item.handoutList.length > 0">
																Resources
																<i></i>
															</label>
															<v-spacer></v-spacer>
															<v-btn
																rounded
																v-if="item.type == typeOnDemandVideo"
																:style="{
																	backgroundColor: auditoriumColor.buttonBackgroundColor,
																	color: auditoriumColor.buttonFontColor
																}"
																class="ma-6 px-12"
																@click="saveAuditoriumState(); navigateToPresentationPage('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + item.dataMap.presentationScheduleId + '/' + item.id);"
															>Start</v-btn>
															<v-btn
																v-else-if="item.type == typeZoomWebinar && item.dataMap.toEndTime >= 0"
																rounded
																:style="{
																	backgroundColor: auditoriumColor.buttonBackgroundColor,
																	color: auditoriumColor.buttonFontColor
																}"
																class="ma-6 px-12"
																@click="saveAuditoriumState(); navigateToPresentationPage('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + item.dataMap.presentationScheduleId + '/' + item.id);"
															>Start</v-btn>
															<v-btn
																v-else-if="item.type == typeZoomMeeting && item.dataMap.toEndTime >= 0"
																rounded
																:style="{
																	backgroundColor: auditoriumColor.buttonBackgroundColor,
																	color: auditoriumColor.buttonFontColor
																}"
																class="ma-6 px-12"
																@click="saveAuditoriumState(); navigateToPresentationPage('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + item.dataMap.presentationScheduleId + '/' + item.id);"
															>Start</v-btn>
															<v-btn
																v-else-if="item.type == typeTeamsMeeting && item.dataMap.toEndTime >= 0"
																rounded
																:style="{
																	backgroundColor: auditoriumColor.buttonBackgroundColor,
																	color: auditoriumColor.buttonFontColor
																}"
																class="ma-6 px-12"
																@click="saveAuditoriumState(); navigateToPresentationPage('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + item.dataMap.presentationScheduleId + '/' + item.id);"
															>Start</v-btn>
															<v-btn
																v-else-if="item.type == typeVimeoLive && item.dataMap.toEndTime >= 0"
																rounded
																:style="{
																	backgroundColor: auditoriumColor.buttonBackgroundColor,
																	color: auditoriumColor.buttonFontColor
																}"
																class="ma-6 px-12"
																@click="saveAuditoriumState(); navigateToPresentationPage('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + item.dataMap.presentationScheduleId + '/' + item.id);"
															>Start</v-btn>
															<v-btn
																v-else-if="item.type == typePresentationUrl && item.dataMap.toEndTime >= 0"
																rounded
																:style="{
																	backgroundColor: auditoriumColor.buttonBackgroundColor,
																	color: auditoriumColor.buttonFontColor
																}"
																class="ma-6 px-12"
																@click="saveAuditoriumState(); navigateToPresentationPage('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + item.dataMap.presentationScheduleId + '/' + item.id);"
															>Start</v-btn>
															<v-btn
																v-else-if="item.type == typeEmbedCode && item.dataMap.toEndTime >= 0"
																rounded
																:style="{
																	backgroundColor: auditoriumColor.buttonBackgroundColor,
																	color: auditoriumColor.buttonFontColor
																}"
																class="ma-6 px-12"
																@click="saveAuditoriumState(); navigateToPresentationPage('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + item.dataMap.presentationScheduleId + '/' + item.id);"
															>Start</v-btn>
															<v-btn
																v-else-if="item.type == typeTraining && item.dataMap.toEndTime >= 0"
																rounded
																:style="{
																	backgroundColor: auditoriumColor.buttonBackgroundColor,
																	color: auditoriumColor.buttonFontColor
																}"
																class="ma-6 px-12"
																@click="saveAuditoriumState(); navigateToPresentationPage('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + item.dataMap.presentationScheduleId + '/' + item.id);"
															>Start</v-btn>
															<v-btn
																v-else-if="item.type == typePreRecordedVideo && item.dataMap.toStartTime <= 5 && item.dataMap.toEndTime >= 0"
																rounded
																:style="{
																	backgroundColor: auditoriumColor.buttonBackgroundColor,
																	color: auditoriumColor.buttonFontColor
																}"
																class="ma-6 px-12"
																@click="saveAuditoriumState();
																		inIframe() ?
																			navigateToPresentationPage('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + item.dataMap.presentationScheduleId + '/' + item.id)
																			: showDialogSimuliveVideo('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + item.dataMap.presentationScheduleId + '/' + item.id);"
															>Start</v-btn>
															<span
																v-if="item.type != typeOnDemandVideo && item.dataMap.toStartTime >= 0"
															>Scheduled to start in {{ formatTime(item.dataMap.toStartTime) }}</span>
															<span
																v-if="(item.type == typeZoomWebinar || item.type == typeZoomMeeting || item.type == typeVimeoLive) && item.dataMap.toEndTime < 0"
															>This live session has ended</span>
															<span v-else-if="(item.type == typePreRecordedVideo) && item.dataMap.toEndTime < 0">Session ended</span>
														</div>
														<div class="content" v-for="(itemHandout, indexItemHandout) in item.handoutList" :key="indexItemHandout">
															<v-row class="py-2" v-if="itemHandout">
																<v-col cols="12" sm="6">
																	<v-icon>mdi-file-document-outline</v-icon>
																	<span>{{ itemHandout.title }}</span>
																</v-col>
																<v-col cols="12" sm="4">
																	<v-btn
																		rounded
																		small
																		:style="{
																			backgroundColor: auditoriumColor.buttonBackgroundColor,
																			color: auditoriumColor.buttonFontColor
																		}"
																		class="mx-4"
																		v-if="itemHandout"
																		@click="saveToMyDocument(item.id, itemHandout.id)"
																	>Save To My Document</v-btn>
																</v-col>
																<v-col cols="12" sm="2">
																	<v-btn
																		rounded
																		small
																		:style="{
																			backgroundColor: auditoriumColor.buttonBackgroundColor,
																			color: auditoriumColor.buttonFontColor
																		}"
																		class="mx-4"
																		v-if="itemHandout"
																		@click="download(itemHandout.value)"
																	>Download</v-btn>
																</v-col>
															</v-row>
															<hr class="mx-n4" v-if="itemHandout.id" />
														</div>
													</section>
												</v-col>
											</v-row>
										</v-container>
									</v-row>
								</div>
							</v-expansion-panel-content>
						</v-expansion-panel>

                        <v-expansion-panel v-if="onDemandList" style="background-color: #FFFFFF00;">
							<v-expansion-panel-header expand-icon :style="{backgroundColor: auditoriumColor.dateBackgroundColor}">
								<v-row class="d-flex align-center mx-4">
									<v-container style="padding: 0;" class="text-center">
										<span style="font-weight: bold;" :style="{color: auditoriumColor.fontColor}">On Demand</span>
									</v-container>
								</v-row>
							</v-expansion-panel-header>
							<v-expansion-panel-content class="presentation">
								<div>
									<v-row
										v-for="(onDemandItem, onDemandIndex) in onDemandList"
                                        :key="onDemandIndex"
										:style="{
											backgroundColor: auditoriumColor.backgroundColor,
											color: auditoriumColor.fontColor,
										}"
										style="margin-left: 0; margin-right: 0;"
									>
										<v-container style="padding: 0;">
											<v-row class="mx-4" v-if="onDemandIndex == 0">
												<v-col cols="12" sm="2"></v-col>
												<v-col cols="12" sm="10">
												</v-col>
											</v-row>
											<v-row class="d-flex mx-4" style="justify-content: center;">
												<v-col cols="12" sm="10">
													<h3 style="margin-bottom:10px;">{{ onDemandItem.title }}</h3>
                                                    <p
														style="font-weight: bold;"
                                                        class="mb-5"
													>{{ formatTime12Hours(onDemandItem.dataMap.startDate) }} {{ formatTime12Hours(onDemandItem.dataMap.startTime) }} {{timeZoneText}}</p>
                                                    <div v-for="(topic, indexTopic) in onDemandItem.topicList" :key="indexTopic">
														<div class="d-flex flex-row mb-2" v-for="(presenter, indexPresenter) in topic.presenterList" :key="indexPresenter">
															<v-avatar
																size="80"
																color="teal"
																style="margin-left: 0px; margin-right: 10px;cursor: pointer;"
																@click="selectedPresenterName = presenterName(presenter); selectedPresenterBio = presenter.bio; dialogBio = true; "
															>
																<v-img v-if="presenter.image != null && !imgError[presenter.id]" :src="baseLocation + '/asset/file/user/' + presenter.image + '?c=' + imgCaching" @error="imgError[presenter.id] = !imgError[presenter.id]" />
																<v-img v-else :src="baseLocation + '/resource/image/default-avatar.png'" />
															</v-avatar>
															<div class="mt-3">
																<a
																	style="color: white; text-decoration: none;"
																	@click="selectedPresenterName = presenterName(presenter); selectedPresenterBio = presenter.bio; dialogBio = true; "
																>{{ presenterName(presenter) }}</a>
																<div class="mt-2 body-2" v-if="topic.value != null">{{ topic.value }}</div>
															</div>
															<br />
														</div>
													</div>
													<p class="mt-4 body-2" v-html="onDemandItem.description"></p>

													<section class="accordion">
														<input type="checkbox" name="collapse" :id="indexTrack + '-' + onDemandItem.id" />
														<div class="handle d-flex flex-row align-center">
															<label :for="indexTrack + '-' + onDemandItem.id" v-show="onDemandItem.handoutList && onDemandItem.handoutList.length > 0">
																Resources
																<i></i>
															</label>
															<v-spacer></v-spacer>
															<v-btn
																rounded
																:style="{
																	backgroundColor: auditoriumColor.buttonBackgroundColor,
																	color: auditoriumColor.buttonFontColor
																}"
																class="ma-6 px-12"
																@click="saveAuditoriumState(); navigateToPresentationPage('/' + tenantSlug + '/' + experienceSlug + '/presentation/' + itemTrack.id + '/' + onDemandItem.dataMap.presentationScheduleId + '/' + onDemandItem.id);"
															>Start</v-btn>
														</div>
														<div class="content" v-for="(itemHandout, indexItemHandout) in onDemandItem.handoutList" :key="indexItemHandout">
															<v-row class="py-2" v-if="itemHandout">
																<v-col cols="12" sm="6">
																	<v-icon>mdi-file-document-outline</v-icon>
																	<span>{{ itemHandout.title }}</span>
																</v-col>
																<v-col cols="12" sm="4">
																	<v-btn
																		rounded
																		small
																		:style="{
																			backgroundColor: auditoriumColor.buttonBackgroundColor,
																			color: auditoriumColor.buttonFontColor
																		}"
																		class="mx-4"
																		v-if="itemHandout"
																		@click="saveToMyDocument(itemHandout.presentationId, itemHandout.id)"
																	>Save To My Document</v-btn>
																</v-col>
																<v-col cols="12" sm="2">
																	<v-btn
																		rounded
																		small
																		:style="{
																			backgroundColor: auditoriumColor.buttonBackgroundColor,
																			color: auditoriumColor.buttonFontColor
																		}"
																		class="mx-4"
																		v-if="itemHandout"
																		@click="download(itemHandout.value)"
																	>Download</v-btn>
																</v-col>
															</v-row>
															<hr class="mx-n4" v-if="itemHandout.id" />
														</div>
													</section>
												</v-col>
											</v-row>
										</v-container>
									</v-row>
								</div>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-tab-item>
			</v-tabs-items>
		</v-card>

		<v-row v-if="$store.state.isPoweredBy" style="background-color: black">
			<v-col cols="12" sm="12">
				<div id="v-footer" style="height: 50px; background-color: black" v-if="$store.state.footerText === ''">
                    <p class="text-center" style="color: #cccccc;padding-top: 15px">Powered by <a href="https://v-unite.com/" target="_blank" style="color:#cccccc">V-Unite</a></p>
                </div>
                <div id="v-footer" style="height: 50px; background-color: black" v-else>
                    <p class="text-center" style="color: #cccccc;padding-top: 15px">{{ $store.state.footerText }}</p>
                </div>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogBio" persistent width="800">
			<v-card tile>
				<v-card-title>
					<span class="headline">{{ selectedPresenterName }}</span>
					<v-spacer></v-spacer>
					<v-icon @click="dialogBio = false;">mdi-close</v-icon>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>{{ selectedPresenterBio }}</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSimuliveVideo" fullscreen>
			<v-card tile>
				<v-card-title>
					<v-spacer></v-spacer>
					<v-icon @click="closeDialogSimuliveVideo()">mdi-close</v-icon>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<iframe
					frameborder="0"
					allow="autoplay; encrypted-media"
					style="top:0; left:0; bottom:0; right:0; width:100%; height:100vh; border:none; margin:0; padding:0; "
					scrolling="0"
					:src="simuliveVideoUrl"
					allowfullscreen
				></iframe>
		</v-card>
		</v-dialog>
	</v-main>
</template>

<style>
.presentation > .v-expansion-panel-content__wrap {
	padding: 0;
}

/*
 CSS for the main interaction
*/
.accordion > input[type="checkbox"] {
	position: absolute;
	left: -100vw;
}

.accordion .content {
	overflow-y: hidden;
	height: 0;
	transition: height 0.3s ease;
}

.accordion > input[type="checkbox"]:checked ~ .content {
	height: auto;
	overflow: visible;
}

.accordion label {
	display: block;
}

/*
 Styling
*/

.accordion {
	margin-bottom: 1em;
}

.accordion > input[type="checkbox"]:checked ~ .content {
	padding: 15px;
	border-top: 0;
}

.accordion .handle {
	margin: 0;
	line-height: 1.2em;
	height: 50px;
	border-bottom: 2px solid white;
}

.accordion label {
	color: #fff;
	cursor: pointer;
	font-weight: normal;
	padding: 15px;
}

.accordion .handle i:before {
	font: normal normal normal 24px/1 "Material Design Icons";
	content: "\F0140";
	display: inline-block;
	margin-right: 10px;
	font-size: inherit;
	line-height: 1.556em;
	vertical-align: middle;
}

.accordion > input[type="checkbox"]:checked ~ .handle i:before {
	content: "\F0143";
}

.auditorium_search_bar > div > div > div > input {
	color: var(--input-color) !important;
}
.auditorium_search_bar > div > div > div > input::placeholder {
	color:var(--input-color) !important;
}
.auditorium_search_bar > div > div > div > div > i {
	color: var(--input-color) !important;
}
</style>

<script>
/* eslint-disable */
import axios from "axios";
import store from '../../store'

export default {
	components: {},
	props: ["tenantSlug", "experienceSlug", "trackId", "auditoriumId"],
	data() {
		return {
			valid: true,
			tab: 0,
			panel: 0,
			trackList: [],
			searchTitle: null,
			selectedTrackId: null,
			dateList: [],
			presentationList: [],
			presentationScheduleList: [],
			typeOnDemandVideo: "On-Demand Video",
			typePreRecordedVideo: "Pre-recorded Video",
			typeZoomWebinar: "Zoom Webinar",
			typeZoomMeeting: "Zoom Meeting",
			typeTeamsMeeting: "Teams Meeting",
			typeVimeoLive: "Vimeo Live",
			typePresentationUrl: "Presentation URL",
			typeEmbedCode: "Embed Code",
			typeTraining: "Training",
			experienceId: null,
			expansion: false,
			timeout: null,
			dialogBio: false,
			dialogSimuliveVideo: false,
			simuliveVideoUrl: null,
			selectedPresenterName: null,
			selectedPresenterBio: null,
			auditorium: {},
			timeZoneText: "",
			baseLocation: axios.defaults.baseURL,
			imgError: {},
			imgCaching: this.$root.randomNumber(),
			auditoriumColor: {
				backgroundColor: "#FFFFFFFF",
				additionalBackgroundColor: "#FFFFFFFF",
				dateBackgroundColor: "#FFFFFFFF",
				highlightBackgroundColor: "#FFFFFFFF",
				fontColor: "#FFFFFFFF",
				buttonBackgroundColor: "#FFFFFFFF",
				buttonFontColor: "#FFFFFFFF",
				searchBarColor: "#FFFFFFFF",
				searchBarFontColor: "#FFFFFFFF"
			},
			auditoriumColorDefault: {
				backgroundColor: "#416D74FF",
				additionalBackgroundColor: "#3B5A5FFF",
				dateBackgroundColor: "#1E1E1EFF",
				highlightBackgroundColor: "#1E1E1EFF",
				fontColor: "#FFFFFFFF",
				buttonBackgroundColor: "#EB7226FF",
				buttonFontColor: "#FFFFFFFF",
				searchBarColor: "#000000DE",
				searchBarFontColor: "#FFFFFFFF"
			},
            onDemandList: [],
			odTrackid: null,
		};
	},
	computed: {
		styleObject1() {
			return {
				'--input-color': this.auditoriumColor.searchBarFontColor,
			};
		},
	},
	mounted() {
		document.addEventListener("backbutton", this.closeDialogSimuliveVideo(), false);
		this.findAuditorium();
		this.findAuditoriumColor();
		if (this.$root.showLiveSupport) {
			this.$root.setCurrentUrlLiveSupport(this.$router.currentRoute.path);
		}
	},
	watch: {
		trackId(newTrackId, oldTrackId) {
			if (newTrackId != null) {
				this.listPresentationByTrackId(newTrackId);
			} else {
				this.listPresentationByTrackId(oldTrackId);
			}
		},
		tab(newTab, oldTab) {
			if (newTab != null) {
				this.selectTrack(this.trackList[newTab].id);
			}
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.tab = store.state.auditorium.url === window.location.href ? store.state.auditorium.tab : 0;
			vm.panel = store.state.auditorium.url === window.location.href ? store.state.auditorium.panel : null;
		});
	},
	methods: {
		findAuditorium() {
			axios
				.get("/system/auditorium?id=" + this.auditoriumId)
				.then(response => {
					this.auditorium = response.data;
					if (this.auditorium.timeZoneText) {
						this.timeZoneText = this.auditorium.timeZoneText;
					}
					this.listTrack();
				})
				.catch(() => {});
		},
		listTrack() {
			axios
				.post("/system/track/list", {
					auditoriumId: this.auditoriumId
				})
				.then(response => {
					if (this.trackId) {
						for (let track of response.data) {
							if(this.trackId == track.id){
								this.trackList.push(track);
							}
						}
					} else {
						this.trackList = response.data;
					}
					this.listPresentationByTrackId(this.trackList[this.tab].id);
				})
				.catch(() => {});
		},
		listPresentationByTrackId(id) {
			axios
				.post("/system/presentation/track/list", {
					trackId: id,
					offtrack: false,
					title: this.searchTitle
				})
				.then(response => {
					this.dateList = response.data;
					this.setPanelByToday();
                    this.OndemandList(id);
                    this.testRunUpdateType();
				})
				.catch(() => {})
				.finally(() => {
					this.countDownTimer();
				});
		},

        OndemandList(id) {
			this.odTrackid = id;
			axios
				.post("/system/presentation/ondemand/list", {
					trackId: id,
					title: this.searchTitle
				})
				.then(response => {
                    this.onDemandList = response.data;
				})
				.catch(() => {})
		},

        OndemandListTitle(title) {
			axios
				.post("/system/presentation/ondemand/list", {
					trackId: this.odTrackid,
					title: title
				})
				.then(response => {
                    this.onDemandList = response.data;
				})
				.catch(() => {})
		},

		listPresentationByTrackIdTimezone(id, timezone) {
			axios
				.post("/system/presentation/track/list", {
					trackId: id,
					offtrack: false,
					title: null,
					timezone: timezone
				})
				.then(response => {
					this.dateList = response.data;
					this.setPanelByToday();
				})
				.catch(() => {})
				.finally(() => {
					this.countDownTimer();
				});
		},
		listPresentationByTrackIdTitle(title) {
			axios
				.post("/system/presentation/track/list", {
					offtrack: false,
					title: title,
					auditoriumId: this.auditoriumId
				})
				.then(response => {
					this.dateList = response.data;
					this.setPanelByToday();
                    this.OndemandListTitle(title);
				})
				.catch(() => {})
				.finally(() => {
					this.countDownTimer();
				});
		},
		listPresentationByTrackIdTitle2(title) {
			axios
				.post("/system/presentation/track/list", {
					trackId: this.odTrackid,
					offtrack: false,
					title: title,
					auditoriumId: this.auditoriumId
				})
				.then(response => {
					this.dateList = response.data;
					this.setPanelByToday();
                    this.OndemandListTitle(title);
				})
				.catch(() => {})
				.finally(() => {
					this.countDownTimer();
				});
		},


		setPanelByToday(){
			this.panel = null;

			let startDay = new Date();
			startDay.setHours(0,0,0,0);

			for(let index = 0; index < this.dateList.length; index++){
				let dateSplit = this.dateList[index].value.split(', ');
				let startTime = new Date(dateSplit[1] + ', ' + dateSplit[2]);
				if(startDay.getTime() === startTime.getTime()){
					this.panel = index;
					break;
				}
			}
		},
		showDialogSimuliveVideo(path) {
			this.simuliveVideoUrl = window.location.origin + '/#'+ path + (this.trackId != null ? "/track" : "");
			this.dialogSimuliveVideo = true;
		},
		closeDialogSimuliveVideo() {
			this.simuliveVideoUrl = null;
			this.dialogSimuliveVideo = false;
		},
		countDownTimer() {
			for (let date of this.dateList) {
				for (let session of date.sessionList) {
					for (let presentation of session.presentationList) {
						if (presentation.dataMap.toEndTime >= -5) {
							presentation.dataMap.toStartTime -= 1;
							presentation.dataMap.toEndTime -= 1;
							presentation.dataMap.toLiveTime += 1;
							this.$forceUpdate();
						}
					}
				}
			}
			this.timeout = setTimeout(() => {
				clearTimeout(this.timeout);
				this.countDownTimer();
			}, 1000);
		},
		download(name) {
			location.href = this.baseLocation + "/asset/file/" + name + "?download&time=" + new Date();
		},
		saveToMyDocument(presentationId, documentId) {
			axios.post("/system/document/briefcase/add", {
				experienceUserId: this.$store.state.principal.id,
				documentId: documentId
			})
			.then((response) => {
				if (response.data == "Saved") {
					let activityLog = {
						dataMap: { presentationId: presentationId, documentId: documentId },
						type: "Add_to_my_documents"
					};
					this.$root.saveActivityLog(activityLog);
				}
			});;
		},
		presenterName(presenter) {
			var firstName = presenter.firstName != null ? this.$root.textify(presenter.firstName) : "";
			var lastName = presenter.lastName != null ? this.$root.textify(presenter.lastName) : "";
			var title = presenter.title != null ? this.$root.textify(presenter.title) : "";
			return firstName + " " + lastName + " " + title;
		},
		goToZoomWebinar(url) {
			window.location.href = url;
		},
		formatTime(seconds) {
			if (seconds > 86400) {
				return "more than a day";
			} else {
				return new Date(seconds * 1000).toISOString().substr(11, 8);
			}
		},
		profilePicture(imageName) {
			return this.baseLocation + "/asset/file/user/" + imageName;
		},
		formatTime12Hours(time) {
			time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

			if (time.length > 1) {
				time = time.slice(1);
				time[5] = +time[0] < 12 ? "AM" : "PM";
				time[0] = +time[0] % 12 || 12;
			}

			return time.join("");
		},
		scrollToTop(id) {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		selectTrack(id) {
			// this.searchTitle = null;
			this.panel = null;
			this.selectedTrackId = id;
			this.listPresentationByTrackId(id);
		},
		saveAuditoriumState() {
			this.$store.state.auditorium.tab = this.tab;
			this.$store.state.auditorium.panel = this.panel;
			this.$store.state.auditorium.url = window.location.href;
		},
		navigateToPresentationPage(path) {
			window.location.href = window.location.origin + '/#'+ path + (this.trackId != null ? "/track" : "");
		},
		findAuditoriumColor() {
			axios
				.post("/system/experienceColors/find",{
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug,
					page: "Auditorium"
				})
				.then(response => {
					if (response.data) {
						this.auditoriumColor = response.data;
					} else {
						this.auditoriumColor = this.auditoriumColorDefault;
					}
				})
				.catch(() => {});
		},
		inIframe () {
			try {
					return window.self !== window.top;
				} catch (e) {
					return true;
				}
		}
	}
};
</script>